module.exports = __webpack_public_path__ + "img/indent.c2f623f7.svg";